import React from "react";
import "./ErrorMessage.scss";
const ErrorMessage = ({ show = false, message = "Invalid input" }) => {
  return show ? (
    <div className="error-message-wrapper">
      {message?.length ? message : "Invalid input"}
    </div>
  ) : null;
};

export default ErrorMessage;
